var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-floating"},[_c('button',{staticClass:"button is-primary body2-bold",style:(_vm.buttonStyle),on:{"click":function($event){return _vm.$emit('clicked')}}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }